<template>
  <div class="special-offer-trial-ads-page">
    <sub-header-section
      :pageTitle="$tc('SpecialOfferPage.title')"
      :backLink="'/home'"
      :isPurchasingInAppPurchase="isPurchasingInAppPurchase"
    />

    <mypage-switch-to-paid-plan-pane :isTrialAds="true" />
  </div>
</template>

<script lang="ts">
import { defineComponent, Ref } from '@vue/composition-api'
import SubHeaderSection from '@/components/common/Header/SubHeaderSection.vue'
import MypageSwitchToPaidPlanPane from '@/components/MypageSwitchToPaidPlanPage/MypageSwitchToPaidPlanPane.vue'
import StoreUtil from '@/store/StoreUtil'

/**
 * お得なお知らせ: ログイン後に表示するトライアル広告ページ
 */
export default defineComponent({
  name: 'SpecialOfferTrialAdsPage',
  components: {
    SubHeaderSection,
    MypageSwitchToPaidPlanPane,
  },
  setup() {
    const mypagePageStore = StoreUtil.useStore('MypagePageStore')
    const { isPurchasingInAppPurchase } = mypagePageStore

    return {
      isPurchasingInAppPurchase: isPurchasingInAppPurchase as Ref<boolean>,
    }
  },
})
</script>

<style lang="scss" scoped>
.special-offer-trial-ads-page {
  background: $gray1;
  min-height: var(--screen-height);
  padding-bottom: env(safe-area-inset-bottom);
}
</style>
